const MAX_DESCRIPTION_CHARS = 200;
const MAX_FEATURE_CHARS = 85;
const MAX_FEATURES_SHOWN = 4;

/** Reduz texto longo para o resumo do checkout (Firestore mantém o texto completo). */
export function summarizePlanDescription(description: string): string {
  const collapsed = description.trim().replace(/\s+/g, ' ');
  if (!collapsed) return '';
  if (collapsed.length <= MAX_DESCRIPTION_CHARS) return collapsed;

  const excerpt = collapsed.slice(0, MAX_DESCRIPTION_CHARS);
  const lastSentenceEnd = Math.max(
    excerpt.lastIndexOf('. '),
    excerpt.lastIndexOf('! '),
    excerpt.lastIndexOf('? ')
  );
  if (lastSentenceEnd > 60) {
    return excerpt.slice(0, lastSentenceEnd + 1).trim();
  }

  const lastSpace = excerpt.lastIndexOf(' ');
  const cut = lastSpace > 40 ? excerpt.slice(0, lastSpace) : excerpt;
  return `${cut.trim()}…`;
}

/** Lista enxuta de benefícios para o checkout. */
export function summarizePlanFeatures(features: string[]): {
  items: string[];
  hiddenCount: number;
} {
  const cleaned = features.map((f) => f.trim()).filter(Boolean);
  const items = cleaned.slice(0, MAX_FEATURES_SHOWN).map((feature) => {
    if (feature.length <= MAX_FEATURE_CHARS) return feature;
    const excerpt = feature.slice(0, MAX_FEATURE_CHARS);
    const lastSpace = excerpt.lastIndexOf(' ');
    const cut = lastSpace > 30 ? excerpt.slice(0, lastSpace) : excerpt;
    return `${cut.trim()}…`;
  });

  return {
    items,
    hiddenCount: Math.max(0, cleaned.length - items.length),
  };
}
